import { render, staticRenderFns } from "./shang-pin-yuan-liao.vue?vue&type=template&id=a4b04892&scoped=true"
import script from "./shang-pin-yuan-liao.vue?vue&type=script&lang=js"
export * from "./shang-pin-yuan-liao.vue?vue&type=script&lang=js"
import style0 from "./shang-pin-yuan-liao.vue?vue&type=style&index=0&id=a4b04892&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b04892",
  null
  
)

export default component.exports